var map = {
	"./br.svg": "eb23",
	"./de.svg": "f2ab",
	"./en.svg": "1aad",
	"./es.svg": "7bc4",
	"./fr.svg": "0e0c",
	"./hi.svg": "5c95",
	"./it.svg": "b9b0",
	"./ja.svg": "be8f",
	"./km.svg": "20f3",
	"./my.svg": "b57e",
	"./nocountry.svg": "0f9f",
	"./ru.svg": "6acd",
	"./sa.svg": "aad0",
	"./sk.svg": "9067",
	"./sw.svg": "903b",
	"./tr.svg": "9e91",
	"./ur.svg": "fa44",
	"./vi.svg": "7c1f",
	"./zh.svg": "06eb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8702";